import { useEffect, useState } from "react";

import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { VBox } from "@/components/VBox";
import { HBox } from "@/components/HBox";
import { PitchForm } from "./[pitchId]/update";
import { LoadingButton, Alert } from "@mui/lab";
import { Button } from "@mui/material";

import i18n from '@/i18n'


const CREATE_MUTATION = gql`
  mutation upsertPitch($releaseId: ID!, $pressText: String!, $streamUrl: String, $email: String, $source: String!, $handled: Date) {
    upsertPitch(
      releaseId: $releaseId,
      pressText: $pressText,
      streamUrl: $streamUrl,
      email: $email,
      handled: $handled,
      source: $source
    ) {
      pitch {
        id
        streamUrl
        pressText
        handled
        source
        release {
          id
          slug
          name
        }
      }  
    }
  }
`

export function CreatePitchForm({
  releaseId,
  onClose = () => console.warn('onClose pitch form not implemented'),
  onCreated = () => console.warn('onCreated pitch not implemented')
}) {
  const [upsertPitchMutation, { loading: submitting, error: submitError }] = useMutation(CREATE_MUTATION);

  const handleSubmit = event => {
    event.preventDefault();
    upsertPitchMutation({
      variables: {
        releaseId,
        ...values
      }
    }).then(({ data }) => {
      const pitch = data.upsertPitch.pitch
      if (!pitch) {
        throw new Error('Pitch is undefined')
      }
      if (!pitch.id) {
        throw new Error('Created pitch lacks ID')
      }
      if (!pitch.pressText) {
        throw new Error('Pitch lacks press text')
      }
      if (!pitch.release) {
        throw new Error('Pitch lacks release')
      }
      if (!pitch.release.name) {
        throw new Error('Pitch lacks release name')
      }
      if (!pitch.source) {
        throw new Error('Source is undefined')
      }
      if (!pitch.streamUrl) {
        console.warn('Pitch lacks stream URL')
      }
      onCreated(pitch)
      onClose()
    }).catch(e => {
      console.error(e)
    })
    return false;
  }

  const handleValueChanged = (newValues) => {
    setValues(newValues)
  }

  const [values, setValues] = useState({ 'source': 'internal' })

  if (values) {
    return (
      <form onSubmit={handleSubmit}>
        <VBox>
          {submitError && <Alert color="danger">{i18n.t('an-error-occurred-during-submission')}</Alert>}
          <PitchForm releaseId={releaseId} onUpdateValues={handleValueChanged} values={values} />
          <HBox>
            <LoadingButton
              loading={submitting}
              variant="contained"
              color="error"
              type="submit"
            >
              {i18n.t('save')}
            </LoadingButton>
            <Button
              variant="secondary"
              onClick={() => onClose()}
            >
              {i18n.t('cancel')}
            </Button>
          </HBox>
        </VBox>
      </form>
    )
  }
}
